(() => {
  if (window.DSCartRecommendationAutoscroll) {
    window.DSCartRecommendationAutoscroll.scan();
    return;
  }

  const selector = '.ds-cart-autoscroll';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeTracks = new WeakMap();

  function removeLegacyClones(track) {
    track.querySelectorAll('[data-ds-marquee-clone="true"]').forEach((clone) => clone.remove());
  }

  function init(root) {
    if (!root) return;

    const viewport = root.querySelector('.slider');
    const track = viewport && viewport.querySelector('ul.slider__grid');
    if (!viewport || !track || activeTracks.get(root) === track) return;

    removeLegacyClones(track);
    const products = Array.from(track.children);
    if (products.length < 2) return;

    root.dataset.dsAutoscrollReady = 'true';
    root.dataset.dsOriginalCount = String(products.length);
    root.dataset.dsRenderedCount = String(products.length);
    activeTracks.set(root, track);

    if (reducedMotion.matches) {
      track.style.transform = '';
      return;
    }

    let offset = viewport.scrollLeft || 0;
    let paused = false;
    let resumeTimer = 0;
    let lastFrame = performance.now();

    const pause = () => {
      paused = true;
      window.clearTimeout(resumeTimer);
    };
    const resume = (delay = 0) => {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
        lastFrame = performance.now();
      }, delay);
    };

    root.addEventListener('pointerenter', pause);
    root.addEventListener('pointerleave', () => resume());
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', () => resume(1000));
    root.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('touchend', () => resume(2500), { passive: true });
    root.addEventListener('touchcancel', () => resume(2500), { passive: true });

    function firstSlideStep() {
      const first = track.firstElementChild;
      if (!first) return 0;
      const second = first.nextElementSibling;
      if (second) return Math.max(1, second.offsetLeft - first.offsetLeft);
      const trackStyle = window.getComputedStyle(track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      return Math.max(1, first.getBoundingClientRect().width + gap);
    }

    function frame(now) {
      if (!root.isConnected || !track.isConnected || activeTracks.get(root) !== track) return;

      const elapsed = Math.min(now - lastFrame, 40);
      lastFrame = now;

      if (!paused && !document.hidden) {
        offset += 0.42 * (elapsed / 16.667);
        let step = firstSlideStep();

        while (step > 0 && offset >= step && track.children.length > 1) {
          offset -= step;
          track.appendChild(track.firstElementChild);
          step = firstSlideStep();
        }

        // Animate the real scroll position so the carousel remains accessible,
        // measurable and functional in browsers that suppress transforms on
        // overflow tracks. Reordering the first slide keeps the loop seamless.
        track.style.transform = '';
        viewport.scrollLeft = offset;
      }

      window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  function scan(scope = document) {
    if (scope.matches && scope.matches(selector)) init(scope);
    scope.querySelectorAll && scope.querySelectorAll(selector).forEach(init);
  }

  let scanQueued = false;
  const observer = new MutationObserver(() => {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  });

  function start() {
    scan();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.DSCartRecommendationAutoscroll = { scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', () => scan());
  document.addEventListener('on:cart:after-merge', () => scan());
  document.addEventListener('on:line-item:change', () => scan());
})();
